import { PageTabs } from '../../components/ui/PageTabs'
import BasePage from '../basePage'
import { TabSelect } from './TabSelect'
import { useQueryParam } from 'use-query-params'
import { motion } from "framer-motion";
import { useMenu } from '../../store/global/useMenu';
import { ClipboardList, ListTodo } from 'lucide-react';
import { useCallback } from "react";

function Configuracoes() {
  const [tab, setTap] = useQueryParam("tab");
  const menuSize = useMenu(st => st.data.size)

  const pageTitle = useCallback(() => {
    switch (tab) {
      case 'services':
        return <><ListTodo className='w-7 h-7' />Ativação de serviços</>
      case 'informacoes':
      default:
        return <><ClipboardList className='w-7 h-7' />Informações da loja</>
    }
  }, [tab])

  return (
    <BasePage pageTitle={pageTitle()}>
      <motion.div
        initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        transition={{ duration: 0.3 }}
        className='flex flex-col pr-2'
      >
        <PageTabs
          ariaLabel="Seções das configurações"
          value={tab || "informacoes"}
          onChange={(value) => setTap(value)}
          tabs={[
            { value: "informacoes", label: "Informações da loja" },
            { value: "services", label: "Ativação de serviços" },
          ]}
        />
        <TabSelect tab={tab} />
      </motion.div>
    </BasePage>
  )
}

export default Configuracoes
